// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"d5-z","dimensionLabel":"e5-z","styleChooserControlWrapper":"f5-z","styleChooserControl":"g5-z","disabled":"h5-z","giftCard":"i5-z","styleChooserText":"j5-z"};